import DashboardSidebar from "@/components/DashboardSidebar";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { Separator } from "@/components/ui/separator";
import { SidebarInset, SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import LogoutButton from "@/components/LogoutButton";
import { BreadcrumbsSchema } from "@/schemas/breadcrumbs.schema";
import { z } from "zod";

interface Props {
    children: React.ReactNode,
    breadcrumbs?: z.infer<typeof BreadcrumbsSchema>
}

export function Layout(props: Props) {
    const { children } = props;

    return (
        <SidebarProvider>
            <DashboardSidebar />
            <SidebarInset>
                <header className="dark:bg-black dark:text-white flex h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12">
                    <div className="flex items-center gap-2 px-4 flex-1">
                        <SidebarTrigger className="ml-1" />
                        <Separator orientation="vertical" className="mr-2 h-4" />

                        {/** Start breadcrumbs */}
                        {props?.breadcrumbs?.items && (
                            <Breadcrumb>
                                <BreadcrumbList>
                                    {props?.breadcrumbs?.items.map((breadcrumb, index) => (
                                        <div className="flex items-center" key={index}>
                                            <BreadcrumbItem key={index}>
                                                <BreadcrumbLink href={breadcrumb.href}>
                                                    {breadcrumb.name}
                                                </BreadcrumbLink>
                                            </BreadcrumbItem>
                                            {index < (props?.breadcrumbs?.items?.length ?? 0) - 1 && (
                                                <BreadcrumbSeparator className="ml-3" key={`separator-${index}`} />
                                            )}
                                        </div>
                                    ))}
                                </BreadcrumbList>
                            </Breadcrumb>
                        )}
                        {/** End breadcrumbs */}
                    </div>
                    <div className="ml-auto px-4">
                        {/* Logout button */}
                        <LogoutButton />
                    </div>
                </header>

                <div className="flex flex-1 flex-col gap-4 p-4 pt-0 dark:bg-black dark:text-white">
                    {children}
                </div>

            </SidebarInset>
        </SidebarProvider>
    )
}
